/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the JobExecutions screen.
 */
export const JOB_EXECUTIONS_DATA_IDS = {
  context: `Form field: Context selection`,
  noJobExecutionsFound: `Empty state: No job executions found`,
  refreshJobExecutionsTable: 'Button: Refresh Job Executions Table',
};
